import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormArray, FormControl, FormGroup, FormBuilder } from '@angular/forms';
import { NgbModalRef, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { Application } from 'src/app/shared/models/Application.model';
import { ApplicationService } from '../../../shared/services/application.service';
import { FileExtensionvValidator } from '../../../shared/utils/file.validator';

@Component({
  selector: 'app-attachment-edit-modal',
  templateUrl: './attachment-edit-modal.component.html',
  styleUrls: ['./attachment-edit-modal.component.css'],
})
export class AttachmentEditModalComponent implements OnInit {
  @Output() fileChange: EventEmitter<any> = new EventEmitter<any>();

  @Input() application: Application;
  @Input() attachments: string[];
  @Input() attachmentType: string;
  @Input() title: string;

  attachmentsEditForm = new FormControl();
  destroyed = new Subject();

  attachmentsForm: FormArray;
  modal: NgbModalRef;

  constructor(
    private ngbModal: NgbModal,
    private formBuilder: FormBuilder,
    private applicationService: ApplicationService
  ) {
    this.attachmentsForm = this.formBuilder.array(
      [],
      [FileExtensionvValidator('png, pdf, txt, jpg')]
    );
  }

  ngOnInit(): void {
    this.attachmentsEditForm.valueChanges
      .pipe(takeUntil(this.destroyed))
      .subscribe((file) => {
        if (!!file) {
          this.attachmentsForm.push(new FormControl(file));
        }
      });
  }

  ngOnDestroy() {
    this.destroyed.next();
  }

  onRemoveFileClick(index: number, evt: MouseEvent) {
    this.attachmentsForm.removeAt(index);
    evt.preventDefault();
  }

  onOpenModal(content) {
    this.modal = this.ngbModal.open(content, { centered: true });
  }

  onAttachmentSubmit() {
    var filesWithId = this.attachmentsForm.value.map((item) => ({
      ...item,
      Id: this.application.Id,
      GrundTyp: this.attachmentType,
    }));

    this.applicationService.addApplicationFiles(filesWithId);
    this.attachmentsForm.clear();
    this.modal.dismiss();
    this.fileChange.emit();
  }
}
